export default __webpack_public_path__ + "static/media/template_pro__0003_24---VivekRaj.b2234714.png";